export default {
      id: "female-usage",
      viewBox: "0 0 13 27",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#female",
      toString: function () {
        return this.url;
      }
    }